module.exports = __webpack_public_path__ + "static/media/page-memberNotice.049336af.jpg";